export function TabbedLayoutTopBarVerticalSeperator() {
  return <div className="mx-2 my-4  w-px self-stretch bg-gray-400 dark:bg-gray-600"></div>;
}
